<div class="panel">
    <div class="panel-header">
        <h1>Trip Planner Color Settings</h1>
    </div>

    <div class="flex">
        <div>
            <b>Event related</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="style.tripPlanner.event.color.isDefault"
                    (ngModelChange)="toDefault('event')">
                    <mat-radio-button [value]="true">
                        Use Default
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        Customize
                    </mat-radio-button>
                    <input [value]="style.tripPlanner.event.color.value"
                        [style.background]="style.tripPlanner.event.color.value" [cpCancelButton]="true"
                        [disabled]="style.tripPlanner.event.color.isDefault" (colorPickerChange)="chooseColor()"
                        [(colorPicker)]="style.tripPlanner.event.color.value" />
                </mat-radio-group>
            </div>
        </div>

        <div>
            <b>Place related</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="style.tripPlanner.place.color.isDefault"
                    (ngModelChange)="toDefault('place')">
                    <mat-radio-button [value]="true">
                        Use Default
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        Customize
                    </mat-radio-button>
                    <input [value]="style.tripPlanner.place.color.value"
                        [style.background]="style.tripPlanner.place.color.value" [cpCancelButton]="true"
                        [disabled]="style.tripPlanner.place.color.isDefault" (colorPickerChange)="chooseColor()"
                        [(colorPicker)]="style.tripPlanner.place.color.value" />
                </mat-radio-group>
            </div>
        </div>

        <div>
            <b>Itinerary related</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="style.tripPlanner.tour.color.isDefault"
                    (ngModelChange)="toDefault('tour')">
                    <mat-radio-button [value]="true">
                        Use Default
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        Customize
                    </mat-radio-button>
                    <input [value]="style.tripPlanner.tour.color.value"
                        [style.background]="style.tripPlanner.tour.color.value" [cpCancelButton]="true"
                        [disabled]="style.tripPlanner.tour.color.isDefault" (colorPickerChange)="chooseColor()"
                        [(colorPicker)]="style.tripPlanner.tour.color.value" />
                </mat-radio-group>
            </div>
        </div>

        <div>
            <b>My Trip related</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="style.tripPlanner.trip.color.isDefault"
                    (ngModelChange)="toDefault('trip')">
                    <mat-radio-button [value]="true">
                        Use Default
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        Customize
                    </mat-radio-button>
                    <input [value]="style.tripPlanner.trip.color.value"
                        [style.background]="style.tripPlanner.trip.color.value" [cpCancelButton]="true"
                        [disabled]="style.tripPlanner.trip.color.isDefault" (colorPickerChange)="chooseColor()"
                        [(colorPicker)]="style.tripPlanner.trip.color.value" />
                </mat-radio-group>
            </div>
        </div>

        <div>
            <b>Buttons</b>
            <div class="group">
                <mat-radio-group class="radio-group" [(ngModel)]="style.tripPlanner.buttons.color.isDefault"
                    (ngModelChange)="toDefault('buttons')">
                    <mat-radio-button [value]="true">
                        Use Default
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                        Customize
                    </mat-radio-button>
                    <input [value]="style.tripPlanner.buttons.color.value"
                        [style.background]="style.tripPlanner.buttons.color.value" [cpCancelButton]="true"
                        [disabled]="style.tripPlanner.buttons.color.isDefault" (colorPickerChange)="chooseColor()"
                        [cpPosition]="'left'" [(colorPicker)]="style.tripPlanner.buttons.color.value" />
                </mat-radio-group>
            </div>
        </div>
    </div>

    <div class="panel-header preview-header tp-preview">
        <h1>Preview</h1>

        <div style="background-color: #eef5f9;padding: 24px;">
            <div class="p-section p-top">
                <div style="width: 10%;height: 50px;text-align: center;line-height: 50px;color: white"
                    [style.background]="style.tripPlanner.trip.color.value">Login
                </div>

                <div class="p-dates">
                    <div class="p-date"><mat-icon
                            [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>
                    <div class="p-date"><mat-icon
                            [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>
                </div>
            </div>

            <div class="p-section m-t-3" style="gap: 16px;display: flex">
                <div style="transition: 300ms linear all" [style.width]="leftPartWidth">
                    <div class="flex" name>
                        <div [style.background]="style.tripPlanner.event.color.value"
                            (click)="previewSelectedTab='event'">Events
                        </div>
                        <div [style.background]="style.tripPlanner.place.color.value"
                            (click)="previewSelectedTab='place'">Places
                        </div>
                        <div [style.background]="style.tripPlanner.tour.color.value"
                            (click)="previewSelectedTab='tour'">Itineraries
                        </div>
                        <div [style.background]="style.tripPlanner.trip.color.value"
                            (click)="previewSelectedTab='trip'">My Trips
                        </div>
                    </div>
                    <div name style="border-top:1px solid white"
                        [style.background]="style.tripPlanner[previewSelectedTab].color.value">
                        {{previewSelectedTab.toUpperCase()}}</div>

                    <div *ngIf="!isOnTourOrTrip">
                        <div style="display: flex;flex-direction: row-reverse">
                            <div [style.background]="style.tripPlanner.buttons.color.value"
                                style="position:relative;right: 0; padding: 6px 12px;color:white;margin: 8px 0;font-size: 12px;display: inline-block">
                                NEXT PAGE</div>
                        </div>
                        <div class="cards-wrap">
                            <div *ngFor="let card of [1,2,3,4,5,6,7,8]" class="p-cards">
                                <img [src]="defaultImg" alt="img" width="100%">
                                <div *ngIf="previewSelectedTab==='event'"
                                    [style.background]="style.tripPlanner.event.color.value">{{timeSample}}</div>
                                <div class="flex">
                                    <div [style.background]="style.tripPlanner.place.color.value">Details</div>
                                    <div [style.background]="style.tripPlanner.buttons.color.value">Add to trip</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isOnTour">
                        <img [src]="tourSideImg" alt="img" width="100%" style="max-height: 500px">
                    </div>
                    <div *ngIf="isOnTrip" class="p-trip-left">
                        <div *ngFor="let card of [1,2]" class="relative m-b-1">
                            <img [src]="defaultImg" alt="img" width="100%">
                            <div name class="text-left" [style.background]="style.tripPlanner.buttons.color.value">Trip
                                name</div>
                            <div class="p-stop" [style.background]="style.tripPlanner.trip.color.value">3 stops</div>
                        </div>

                        <div class="flex m-t-1 m-b-3" style="gap: 8px;">
                            <div name [style.background]="style.tripPlanner.trip.color.value">Create trip</div>
                            <div name [style.background]="style.tripPlanner.buttons.color.value">Share trip</div>
                            <div name [style.background]="style.tripPlanner.buttons.color.value">Export trip</div>
                        </div>
                    </div>
                </div>
                <div style="transition: 300ms linear all" [style.width]="rightPartWidth">
                    <div *ngIf="!isOnTourOrTrip">
                        <img [src]="tpBG" alt="img" width="100%">
                        <p style="padding: 12px 24px;text-align: center">It's time to hit the road! Explore restaurants,
                            attractions, shopping, and more points of interest. Add sites to do and see, save your trip,
                            print, or share to get started. Start planning today!</p>
                        <div class="flex start-icons">
                            <div [style.background]="style.tripPlanner.event.color.value">
                                <mat-icon>date_range</mat-icon>
                            </div>
                            <div [style.background]="style.tripPlanner.place.color.value">
                                <mat-icon>room</mat-icon>
                            </div>
                            <div [style.background]="style.tripPlanner.tour.color.value">
                                <mat-icon>directions_car</mat-icon>
                            </div>
                            <div [style.background]="style.tripPlanner.trip.color.value">
                                <mat-icon>work</mat-icon>
                            </div>
                        </div>
                        <div class="p-dates">
                            <div class="p-date"><mat-icon
                                    [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>
                            <div class="p-date"><mat-icon
                                    [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>
                            <div class="p-start" [style.background]="style.tripPlanner.buttons.color.value">START</div>
                        </div>
                    </div>
                    <div *ngIf="isOnTour" class="p-tour">
                        <div *ngFor="let card of [1,2,3,4,5,6]">
                            <img [src]="defaultImg" alt="img" width="100%">
                            <div name [style.background]="style.tripPlanner.tour.color.value">Itinerary name</div>
                        </div>
                    </div>
                    <div *ngIf="isOnTrip" class="relative">
                        <img [src]="mapImg" alt="img" width="100%" style="max-height: 500px">
                        <div class="flex" style="justify-content: center">
                            <div name class="p-gps" [style.background]="style.tripPlanner.place.color.value">GPS
                                Direction</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <ig-button size="md" (trigger)="saveColor($event)">save</ig-button>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/customization/style/trip.planner.color.settings/trip.planner.color.settings.component.html